module.exports = __webpack_public_path__ + "static/media/Safe-T28.09144d78.jpg";